// extracted by mini-css-extract-plugin
export default {"pnf_wrapper":"PageNotFound_pnf_wrapper__bh-3R"};